import { createTheme } from '@mui/material'
export const theme = createTheme({
  palette: {
    mode: 'light',
    text: {
      primary: '#575757',
      secondary: '#575757',
    },
  },
  typography: {
    fontSize: 13,
    fontFamily: 'Poppins, sans-serif',
    body1: {
      fontSize: 13,
      overflowWrap: 'break-word',
    },
    h6: {
      fontSize: 15,
    },
    h5: {
      fontSize: 18,
    },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        size: 'small',
        variant: 'outlined',
      },
    },

    MuiButton: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: 32,
          height: 32,
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          width: '100%',
          '& .MuiListSubheader-root': {
            lineHeight: '36px',
          },
        },
      },
    },
  },
})
